import { render, staticRenderFns } from "./EndorsementRequestModal.vue?vue&type=template&id=4c920b9a"
import script from "./EndorsementRequestModal.vue?vue&type=script&lang=js"
export * from "./EndorsementRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports